import { Component, ElementRef, inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { Users } from '@models/user';
import { FileSaverService } from 'ngx-filesaver';
import * as XLSX from 'xlsx';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { I18nPlaceholderDirective } from '../../directives/i18n.directives';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { FilterPipeModule } from 'ngx-filter-pipe';

@Component({
  selector: 'lv-user-list',
  templateUrl: 'user-list.component.html',
  styleUrls: ['user-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, TranslateModule, FormsModule, I18nPlaceholderDirective, RouterLink, FilterPipeModule]
})
export class UserListComponent {
  private userService = inject(Users);
  private saver = inject(FileSaverService);

  @ViewChild('data', { static: true, read: ElementRef }) dataTable: ElementRef;
  users = this.userService.$search();

  userFilter = { name: '', email: '' };

  export() {
    const book = XLSX.utils.table_to_book(this.dataTable.nativeElement);
    const data = XLSX.write(book, { bookType: 'xlsx', type: 'array' });
    this.saver.save(new Blob([data]), 'LearnerVerified-Agents.xlsx');
  }
}
